module.exports = __webpack_public_path__ + "img/life-buoy_1.7b578bda.svg";